import ExportButton from './ExportButton';

const inputClasses =
  'w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 shadow-sm focus:border-emerald-500 focus:outline-none focus:ring-1 focus:ring-emerald-500';

const ReportsFilters = ({
  filters,
  onChange,
  onApply,
  onExport,
  properties = [],
  tours = [],
  hosts = [],
  clients = [],
  showHost = false,
  showProperty = false,
  showTour = false,
  showClient = false,
  showType = false,
  showGroupBy = true,
  applying = false,
  exporting = false,
  loadingMeta = false,
  onReset,
}) => {
  const update = (field, value) => {
    onChange({ ...filters, [field]: value });
  };

  return (
    <div className="flex flex-col gap-3 rounded-xl border border-slate-200 bg-white p-4 shadow-sm lg:flex-row lg:items-end lg:justify-between">
      <div className="grid flex-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
        <div className="space-y-1">
          <label className="text-xs font-semibold uppercase tracking-wide text-slate-600">From</label>
          <input
            type="date"
            value={filters.from || ''}
            onChange={(e) => update('from', e.target.value)}
            className={inputClasses}
          />
        </div>
        <div className="space-y-1">
          <label className="text-xs font-semibold uppercase tracking-wide text-slate-600">To</label>
          <input
            type="date"
            value={filters.to || ''}
            onChange={(e) => update('to', e.target.value)}
            className={inputClasses}
          />
        </div>
        {showHost && (
          <div className="space-y-1">
            <label className="text-xs font-semibold uppercase tracking-wide text-slate-600">Host</label>
            <select
              value={filters.hostId || ''}
              onChange={(e) => update('hostId', e.target.value)}
              className={inputClasses}
              disabled={loadingMeta}
            >
              <option value="">All hosts</option>
              {hosts.map((h) => (
                <option key={h.id} value={h.id}>
                  {h.business_name || h.full_name || `Host #${h.id}`}
                </option>
              ))}
            </select>
          </div>
        )}
        {showProperty && (
          <div className="space-y-1">
            <label className="text-xs font-semibold uppercase tracking-wide text-slate-600">Property</label>
            <select
              value={filters.propertyId || ''}
              onChange={(e) => update('propertyId', e.target.value)}
              className={inputClasses}
              disabled={loadingMeta}
            >
              <option value="">All properties</option>
              {properties.map((p) => (
                <option key={p.id} value={p.id}>
                  {p.title}
                </option>
              ))}
            </select>
          </div>
        )}
        {showTour && (
          <div className="space-y-1">
            <label className="text-xs font-semibold uppercase tracking-wide text-slate-600">Tour</label>
            <select
              value={filters.tourId || ''}
              onChange={(e) => update('tourId', e.target.value)}
              className={inputClasses}
              disabled={loadingMeta}
            >
              <option value="">All tours</option>
              {tours.map((t) => (
                <option key={t.id} value={t.id}>
                  {t.title}
                </option>
              ))}
            </select>
          </div>
        )}
        {showClient && (
          <div className="space-y-1">
            <label className="text-xs font-semibold uppercase tracking-wide text-slate-600">Client</label>
            <select
              value={filters.clientId || ''}
              onChange={(e) => update('clientId', e.target.value)}
              className={inputClasses}
              disabled={loadingMeta}
            >
              <option value="">All clients</option>
              {clients.map((c) => (
                <option key={c.id} value={c.id}>
                  {c.name || c.full_name || c.email || `Client #${c.id}`}
                </option>
              ))}
            </select>
          </div>
        )}
        {showType && (
          <div className="space-y-1">
            <label className="text-xs font-semibold uppercase tracking-wide text-slate-600">Type</label>
            <select
              value={filters.type || 'all'}
              onChange={(e) => update('type', e.target.value)}
              className={inputClasses}
            >
              <option value="all">All revenue</option>
              <option value="property">Property</option>
              <option value="tour">Tour</option>
            </select>
          </div>
        )}
        {showGroupBy && (
          <div className="space-y-1">
            <label className="text-xs font-semibold uppercase tracking-wide text-slate-600">Group by</label>
            <select
              value={filters.groupBy || 'day'}
              onChange={(e) => update('groupBy', e.target.value)}
              className={inputClasses}
            >
              <option value="day">Day</option>
              <option value="week">Week</option>
              <option value="month">Month</option>
            </select>
          </div>
        )}
      </div>
      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={() => onApply(filters)}
          disabled={applying}
          className="inline-flex items-center rounded-lg bg-emerald-600 px-4 py-2 text-sm font-semibold text-white shadow-sm transition hover:bg-emerald-700 disabled:cursor-not-allowed disabled:opacity-60"
        >
          {applying ? 'Loading…' : 'Apply'}
        </button>
        {onReset && (
          <button
            type="button"
            onClick={() => onReset()}
            className="inline-flex items-center rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm font-semibold text-slate-700 shadow-sm transition hover:bg-slate-50"
          >
            Reset
          </button>
        )}
        {onExport && <ExportButton onClick={() => onExport(filters)} loading={exporting} />}
      </div>
    </div>
  );
};

export default ReportsFilters;
